module.exports = __webpack_public_path__ + "static/media/default-audio-image-1.03d47a78.jpg";